import './Imprint.css'

function Imprint(props) {
    return (
        <div className={`${props.mobile ? 'imprint-container-mobile' : 'imprint-container'} p-4 flex flex-col items-start`}> 
            <div className={`flex h-full ${props.mobile ? 'flex-col overflow-y-scroll gap-8' : 'items-center overflow-y-scroll leading-normal text-[clamp(12px,1vw,18px)] gap-32'}`} style={{ lineHeight: '1.4' }}>
                <div className={`${!props.mobile ? 'flex justify-center flex-col h-full' : ''}`}>
                    <span className='font-screen-monitor leading-normal text-[clamp(12px,1.5vw,18px)]' style={{ fontWeight: 'bold', fontSize: props.mobile ? '15px' : '' }}>
                        IMPRINT
                    </span>
                    <br></br>
                    <span className='font-screen-monitor leading-normal text-[12px]'>
                        <br></br>
                        Information according to § 5 TMG
                        <br></br><br></br>
                        DISCLAIMER / LIABILITY FOR CONTENT
                        <br></br><br></br>
                        As a service provider, we are responsible for our own content on this website in accordance with general laws (§ 7 para. 1 TMG). However, according to §§ 8 to 10 TMG, we are not obligated to monitor third-party information or investigate indications of illegal activities. Obligations to remove or block content under general laws remain unaffected. Liability is only possible from the moment a concrete infringement becomes known. If we become aware of legal violations, we will remove such content immediately.
                        <br></br><br></br>
                        LIABILITY FOR LINKS
                        <br></br><br></br>
                        This website contains links to external third-party websites. We have no influence on their content and assume no liability for them. The respective provider or operator of the linked pages is responsible for their content. Linked pages were checked for legal violations at the time of linking, and no illegal content was identifiable. However, permanent content monitoring of linked pages is unreasonable without concrete evidence of a legal violation. If we become aware of such violations, the corresponding links will be removed immediately.
                        <br></br><br></br>
                        COPYRIGHT
                        <br></br><br></br>
                        The content and works created by the provider on this website are subject to German copyright law. Any reproduction, editing, distribution, or commercializa- tion beyond the scope of copyright law requires prior written permission from the respective author. Downloads and copies of this site are permitted only for private, non-commercial use.
                        <br></br><br></br>
                        In cases where content is not created by the provider, third-party copyrights are respected. Such content is specifically identified. If you become aware of a copyright violation, please inform us, and we will promptly remove the affected content.
                        <br></br><br></br>
                        Last updated: 2025
                    </span>
                </div>
                <div style={{ minWidth: '20%' }} className={`${props.mobile ? 'self-start' : ''} font-screen-monitor leading-normal text-[clamp(12px,1.5vw,18px)]`}>
                    <span>
                        PROVIDER
                    </span>
                    <br></br><br></br>
                    <span className='text-[12px]'>
                        Christian Horrer
                        <br></br>
                        Erdmannstraße 5
                        <br></br>
                        10827 Berlin
                        <br></br>
                        Germany
                        <br></br><br></br>
                        info@christian-horrer.com
                        <br></br>
                        www.christian-horrer.com
                        <br></br><br></br>
                        VAT ID: DE347463786
                        <br></br>
                        Tax Number: 232 233/04060
                    </span>
                    <br></br><br></br>
                    CREDITS
                    <br></br><br></br>
                    <span className='text-[12px]'>
                        Code: Phil Szalay
                        <br></br>
                        Typeface: Suisse by Swiss Typefaces
                    </span>
                </div>
            </div>
        </div>
    )
}

export default Imprint;